import React from 'react'

export const FooterAbout: React.FC = () => {
    return (
        <>
            <div className="text-[20px] text-[#FFFFFF] font-bold text-left">
                О нас
            </div>
            <div className="text-[16px] text-left">
                <p className="text-[#6A6A6A] dark:text-[#8A8A8A]">Компания:</p>
                <p className="text-[#FFFFFF]">ООО «Технологии Закупок»</p>
            </div>
            <div className="text-[16px] text-left">
                <p className="text-[#6A6A6A] dark:text-[#8A8A8A]">Адрес:</p>
                <p className="text-[#FFFFFF]">
                    677000, Республика Саха (Якутия), г. Якутск, пр-т Ленина, 1,
                    оф. 511
                </p>
            </div>
        </>
    )
}
